export function isTypeName(item, typename) {
  return item && item.__typename === typename;
}
export function filterByTypenames(items = [], typenames) {
  return items.filter(
    (item) => typeof typenames === "string" ? isTypeName(item, typenames) : typenames.some((typename) => isTypeName(item, typename))
  );
}
export function removeTypename(v) {
  const clone = { ...v };
  delete clone.__typename;
  return clone;
}
export function narrowTypeByProperty(obj, propName) {
  if (obj && propName in obj) {
    return obj;
  }
  return void 0;
}
